export const FREE_DELIVERY_THRESHOLD_CENTS = 350000;
export const LVIV_DELIVERY_COST_CENTS = 35000;

export function deliveryCostCents(subtotalCents, receivingMethod) {
  if (!Number.isSafeInteger(subtotalCents) || subtotalCents < 0) throw new RangeError("Invalid bouquet subtotal");
  if (!["pickup", "delivery"].includes(receivingMethod)) throw new TypeError("Invalid receiving method");
  return receivingMethod === "pickup" || subtotalCents >= FREE_DELIVERY_THRESHOLD_CENTS ? 0 : LVIV_DELIVERY_COST_CENTS;
}
